import React from 'react'
import Markdown from 'markdown-to-jsx'
import ResourcesPopover from '../resources/components/resources-popover'
import LinkNewWindow from './link-new-window'

const MarkdownWrapper = ({ content }) => {
    const replaceModalLinks = (text) => {
        if (!text) {
            return null
        }
        let originalText = text
        // split text into array of strings and components based on ^^^
        let splitText = text.split(/\^\^\^/g)
        // Loop over the elements and if it begins with modal: replace with a span
        let newText = []
        for (let i = 0; i < splitText.length; i = i + 1) {
            if (splitText[i].startsWith('modal-')) {
                // remove all text from modal- to the first colon
                let modalText = splitText[i].split(':')
                let parts = modalText[1].split('~')
                // TODO: Look at the type of modal and render the correct component modal-resource:uuid~linkText
                if (splitText[i].includes('modal-resource')) {
                    newText.push({
                        target: `^^^${splitText[i]}^^^`,
                        content: `<ResourcesPopover key={i} uuid={${parts[0]}} linkText={${parts[1]}} />`
                    })
                } else {
                    // console.log('TODO: Handle this popover type')
                    newText.push({
                        target: splitText[i],
                        content: <span key={i}>{ splitText[i] }</span>
                    })
                }
            } else if (splitText[i].includes('link-new-window~')) {
                let linkData = splitText[i].split('~')
                newText.push({
                    target: `^^^${splitText[i]}^^^`,
                    content: `<LinkNewWindow key={i} link={${linkData[1]}} text={${linkData[2]}} />`
                })
            }
        }
        if (newText.length > 0) {
            // loop over the newText array and replace the target with the content
            for (let i = 0; i < newText.length; i = i + 1) {
                originalText = originalText.replace(newText[i].target, newText[i].content)
            }
        }

        // look for markdown versions of h2 and wrap in a div with class of title-text
        if (originalText.includes('##')) {
            // Use a regular expression to find all h2 headings (## followed by a space and text)
            originalText = originalText.replace(
                /(^|\n)## (.+?)(\n|$)/g,
                (match, p1, p2, p3) => `${p1}<div className="title-wrapper"><div className="title-stroke">##${p2}</div></div>${p3}`
            )
        }

        return (
            <Markdown
                children={originalText}
                options={{
                    overrides: {
                        ResourcesPopover: {
                            component: ResourcesPopover
                        },
                        LinkNewWindow: {
                            component: LinkNewWindow
                        }
                    }
                }} />
        )
    }
    return replaceModalLinks(content)
}

export default MarkdownWrapper
